"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsNotUndefined_1 = __importDefault(require("../typeAssertions/valueIsNotUndefined"));
const valueIsNumber_1 = __importDefault(require("../typeAssertions/valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const getNumberFromUnknown_1 = __importDefault(require("./getNumberFromUnknown"));
const setValueLikeFirebase = ({ data, newValue, path, }) => {
    if (path.length === 0) {
        return newValue;
    }
    const [currentProp, ...restOfPath] = path;
    let indexProp;
    try {
        indexProp = (0, getNumberFromUnknown_1.default)(currentProp);
    }
    catch (_a) {
        indexProp = undefined;
    }
    if ((0, valueIsNotUndefined_1.default)(indexProp) && indexProp >= 0 && indexProp <= 9999) {
        if ((0, valueIsRecord_1.default)(data)) {
            const keys = Object.keys(data);
            const indexKeys = keys
                .map((valueKey) => {
                try {
                    return (0, getNumberFromUnknown_1.default)(valueKey);
                }
                catch (_a) {
                    return undefined;
                }
            })
                .filter(valueIsNumber_1.default);
            if (indexKeys.length > 0 && indexKeys.length === keys.length) {
                const newData = (new Array(indexKeys.length)).fill(null);
                indexKeys.forEach((indexToCopy) => {
                    newData[indexToCopy] = data[indexToCopy];
                });
                newData[indexProp] = setValueLikeFirebase({
                    data: data[indexProp] || null,
                    newValue,
                    path: restOfPath,
                });
                return newData;
            }
            return Object.assign(Object.assign({}, data), { [indexProp]: setValueLikeFirebase({
                    data: data[indexProp] || null,
                    newValue,
                    path: restOfPath,
                }) });
        }
        const originalArray = (0, valueIsArray_1.default)(data) ? data : [];
        const newArray = [...originalArray];
        newArray[indexProp] = setValueLikeFirebase({
            data: originalArray[indexProp] || null,
            newValue,
            path: restOfPath,
        });
        return newArray;
    }
    const originalRecord = (0, valueIsRecord_1.default)(data) || (0, valueIsArray_1.default)(data) ? data : {};
    return Object.assign(Object.assign({}, originalRecord), { [currentProp]: setValueLikeFirebase({
            data: originalRecord[currentProp] || null,
            newValue,
            path: restOfPath,
        }) });
};
exports.default = setValueLikeFirebase;
